// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    // Test Firebase
    apiKey: "AIzaSyDf1Rb8HczCZ-4gquI6yuzX_6oj9KcNj5A",
    authDomain: "gcp-sqo-iflex-thailand-t.firebaseapp.com",
    projectId: "gcp-sqo-iflex-thailand-t",
    storageBucket: "gcp-sqo-iflex-thailand-t.appspot.com",
    messagingSenderId: "366933797587",
    apiURL: "https://iflex-thailand-api-52.syensqo.com/api/",
    nonApiURL: "https://iflex-thailand-api-52.syensqo.com/"

  },
  production: false
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
